/**
 * This Layout is needed for Starter Kit.
 */
import React from "react";
import { Placeholder, LayoutServiceData } from "@sitecore-jss/sitecore-jss-nextjs";
import { Box } from "@chakra-ui/react";
import Favicon from "./components/head/Favicon";
import ReactIconBundle from "./assets/icons/icons.sprite.svg";
import MetaData from "./components/head/MetaData";
import { HeaderBackgroundProvider } from "utils/contexts/headerBackgroundContext";
import { GTMPageviewTracking } from "components/head/GTMTracking";
import Script from "components/head/Script";
import { transparentize } from "polished";

interface LayoutProps {
    layoutData: LayoutServiceData;
}

const Layout = (props: LayoutProps) => {
    const { route, context } = props.layoutData.sitecore;
    const { pageEditing } = context;

    // @ts-expect-error: fields.Key.value is not declared in sitecores own types
    const hasWhiteText = route?.fields?.HeaderColor?.fields.Key?.value === "white" || false;

    return (
        <>
            <MetaData
                {...route?.fields}
                MetadataCanonicalUrl={props.layoutData.sitecore.context.itemPath as string}
            />
            <Favicon />

            {!pageEditing && (
                <>
                    <Script />
                    <GTMPageviewTracking />
                </>
            )}

            {/* root placeholder for the app, which we add components to using route data */}
            <Box
                pt={[
                    "var(--sizes-headerMobileTopHeight)",
                    null,
                    null,
                    "var(--sizes-headerTopHeight)",
                ]}
            >
                <HeaderBackgroundProvider hasFullHero={hasWhiteText}>
                    {route && <Placeholder name="headless-header" rendering={route} />}
                </HeaderBackgroundProvider>
                <Box
                    as="main"
                    bg="white"
                    boxShadow={`0px 50px 56px 0px ${transparentize(0.8, "black")}`}
                    position="relative"
                    zIndex={1}
                >
                    {route && <Placeholder name="headless-main" rendering={route} />}
                </Box>

                {route && <Placeholder name="headless-footer" rendering={route} />}
            </Box>

            <Box sx={{ width: 0, height: 0, overflow: "hidden" }} position="absolute" zIndex={-1}>
                <ReactIconBundle />
            </Box>
        </>
    );
};

export default Layout;
